// Catálogo da tela Relatórios e Indicadores: cada relatório pronto já sabe a fonte, as colunas, os filtros que
// fazem sentido e o agrupamento do gráfico. O usuário só escolhe período/cliente e gera (na tela ou em planilha).
// Os relatórios customizados cadastrados pelo admin entram no mesmo catálogo (definicaoCustomizada).
import { TEXTO_COLORIDO_ESCURO } from "assets/coresTema";
import { ehCarteiraJuridica } from "utils/Carteiras";

// Nome de exibição das colunas que a consulta devolve sem acento (vai para a tabela e para a planilha)
export const ROTULOS_COLUNAS = {
    "Codigo Cliente": "Código Cliente",
    "Data Formalizacao": "Data Formalização",
    "Situacao Acordo": "Situação Acordo",
    "Situacao Parcela": "Situação Parcela",
    "Acrescimo Baixa Parcela": "Acréscimo Baixa Parcela",
    "Data Distribuicao": "Data Distribuição",
    "Situacao Ficha": "Situação Ficha",
    "ID Ocorrencia": "ID Ocorrência",
    "Operador Ocorrencia": "Operador Ocorrência",
    "Tipo Ocorrencia": "Tipo Ocorrência",
    "Data Ocorrencia": "Data Ocorrência",
    "Observacao": "Observação",
    "Titulo": "Título",
    "Descricao": "Descrição",
    "Emissao": "Data Emissão",
    "Criacao": "Data Cadastro",
    "Devolucao": "Data Devolução",
    "Situacao Contrato": "Situação Contrato",
    "Nosso Numero": "Nosso Número",
    "DV Nosso Numero": "DV Nosso Número",
    "Pagamento": "Data Pagamento",
    "Linha Digitavel": "Linha Digitável",
    "Situacao Boleto": "Situação Boleto",
    "Email Informado": "E-mail Informado",
    "Ocorrencia Excluida": "Ocorrência Excluída",
    // Fonte acordos_juridico (relatórios da Cobrança Jurídica)
    "Numero Ficha": "Nº Ficha",
    "Responsavel Ficha": "Responsável da Ficha",
    "Tipo Acao": "Tipo de Ação",
    "Data Cadastro Ficha": "Data de Cadastro",
    "Data Acordo": "Data do Acordo",
    "Ano Acordo": "Ano do Acordo",
    "Mes Acordo": "Mês do Acordo",
    "Plano": "Plano (Parcelas)",
    "% Exito": "% Êxito",
    "Valor Exito": "Valor Êxito",
    "Valor Exito Parcela": "Valor Êxito Parcela",
    "Ultima Ocorrencia": "Última Ocorrência",
    "Data Ultima Ocorrencia": "Data da Última Ocorrência",
    "Ano Vencimento": "Ano do Vencimento",
    "Mes Vencimento": "Mês do Vencimento",
    "Acrescimo": "Acréscimo",
    "Data Lancamento": "Data do Lançamento",
    "Ano Pagamento": "Ano do Pagamento",
    "Mes Pagamento": "Mês do Pagamento",
    "Ano Lancamento": "Ano do Lançamento",
    "Mes Lancamento": "Mês do Lançamento",
    "Dias Atraso": "Dias de Atraso",
    "Valor Acordo Mais HO": "Valor Acordo + HO",
    "ID Acordo Principal": "Acordo Principal",
    // Fonte recebimentos (Controle de Recebimentos)
    "Valor Debito": "Valor do Débito",
    "Dias Atraso Divida": "Dias em Atraso no Acordo",
    "Forma Pagamento": "Forma de Pagamento",
};

export const rotuloColuna = (coluna, aliases) => (aliases && aliases[coluna]) || ROTULOS_COLUNAS[coluna] || coluna;

// Um acordo por linha: sem colunas de parcela a consulta não junta as parcelas (não repete o acordo)
const COLUNAS_ACORDO = ["ID Acordo", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Codigo Cliente", "Carteira",
    "Operador Acordo", "Campanha", "Data Formalizacao", "Valor Original", "Valor Acordo", "Desconto", "Qtd Parcelas", "Situacao Acordo", "Tipo Acordo"];
const COLUNAS_PARCELA = ["ID Acordo", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Operador Acordo", "Data Formalizacao",
    "Valor Acordo", "Num Parcela", "Valor Parcela", "Vencimento Parcela", "Situacao Parcela"];
const COLUNAS_OCORRENCIA = ["ID Ocorrencia", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Carteira", "Operador Ocorrencia",
    "Tipo Ocorrencia", "Data Ocorrencia", "Observacao"];
const COLUNAS_FICHA = ["ID Devedor", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Codigo Cliente", "Carteira", "Status Ficha",
    "Operador Ficha", "Data Distribuicao", "Situacao Ficha"];
const COLUNAS_CONTRATO = ["ID Contrato", "Titulo", "Parcela", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Carteira",
    "Valor Original", "Saldo", "Vencimento", "Situacao Contrato"];
// Auditoria do contato informado na ocorrência e não gravado na ficha (tbDevedorContatoNaoSalvo)
const COLUNAS_CONTATO_NAO_SALVO = ["ID Registro", "Data", "Operador", "Motivo", "Telefone Informado", "Email Informado", "Ficha Sem Contato",
    "Tipo Ocorrencia", "ID Devedor", "Devedor Nome", "Codigo Cliente", "Cliente Nome", "Carteira", "ID Ocorrencia", "Ocorrencia Excluida"];
const COLUNAS_BOLETO = ["ID Boleto", "Nosso Numero", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Valor Boleto", "Valor Pago",
    "Vencimento", "Pagamento", "Emissao", "Situacao Boleto"];

// Cobrança Jurídica (fonte acordos_juridico, no formato dos relatórios do TMK): sem cancelados. Um acordo por linha, com o
// acordo de HO do mesmo mês nas colunas de HO da linha do principal (de outro mês ou sem principal: linha própria, na data
// dele), ou, com as colunas de parcela, uma parcela por linha (as de HO com o ID do acordo principal). O HO fica com o
// nome do cliente, sem "(HO)" (a coluna Ficha HO diz que é honorário)
const COLUNAS_ACORDO_JURIDICO = ["ID Acordo", "Numero Ficha", "Negociador", "Responsavel Ficha", "Cliente Nome", "Ficha HO",
    "Carteira", "Devedor Documento", "Devedor Nome", "Tipo Acao", "Processos", "Data Acordo", "Ano Acordo", "Mes Acordo", "Valor Acordo",
    "Plano", "Parcelas Pagas", "Status Acordo", "Valor HO", "Parcelas HO", "Parcelas Pagas HO", "Status HO", "Valor Acordo Mais HO",
    "% Exito", "Status Ficha", "Ultima Ocorrencia", "Data Cadastro Ficha"];
const COLUNAS_PARCELA_JURIDICO = ["ID Acordo", "ID Acordo Principal", "Numero Ficha", "Responsavel Ficha", "Cliente Nome", "Ficha HO", "Carteira",
    "Devedor Documento", "Devedor Nome", "Tipo Acao", "Data Acordo", "Ano Acordo", "Mes Acordo", "Parcela", "Plano", "Vencimento",
    "Ano Vencimento", "Mes Vencimento", "Valor Acordo", "Valor Parcela", "Acrescimo", "Desconto", "Valor Pago", "Saldo Parcela", "% Exito",
    "Valor Exito", "Data Pagamento", "Ano Pagamento", "Mes Pagamento", "Data Lancamento", "Ano Lancamento", "Mes Lancamento", "Negociador",
    "Status Parcela", "Status Acordo", "Status Ficha", "Ultima Ocorrencia", "Processos", "Data Cadastro Ficha", "Dias Atraso"];
// Controle de Recebimentos (fonte recebimentos): uma linha por parcela, na ordem da planilha de controle da ExtraJudicial,
// com os acordos quebrados. Valor do débito e do acordo só na 1ª linha de cada acordo (a soma conta o acordo uma vez)
const COLUNAS_RECEBIMENTO = ["Cliente Nome", "Devedor Nome", "Devedor Documento", "Carteira", "Negociador", "Data Acordo", "Valor Debito",
    "Dias Atraso Divida", "Valor Acordo", "Parcela", "Plano", "Vencimento", "Valor Parcela", "Status Parcela", "Data Pagamento", "Valor Pago",
    "Comprovante", "Forma Pagamento", "Status Acordo", "ID Acordo", "Numero Ficha", "Codigo Cliente", "Ano Acordo", "Mes Acordo",
    "Ano Pagamento", "Mes Pagamento"];
const soma = (campo, nome) => ({ campo, funcao: "sum", mostrarComo: "normal", nome });
const contagem = (campo, nome) => ({ campo, funcao: "count", mostrarComo: "normal", nome });

// Base inteira é grande demais para a tela e para uma planilha: exige ao menos um destes filtros
const RECORTE_BASE = ["clientes", "carteiras", "operadores"];

// permissao: o grupo só aparece para quem tem o código no perfil; exigeCarteiraJuridica: e para quem vê alguma carteira
// jurídica (cadastro da carteira; mesma visibilidade das outras telas: as carteiras das equipes, sem equipe todas). O backend
// confere os dois
export const GRUPOS_RELATORIOS = [
    { id: "acordos", titulo: "Acordos e parcelas", icone: "handshake", cor: "#2E7D32", corEscura: "#81C784" },
    { id: "atendimento", titulo: "Atendimento", icone: "support_agent", cor: "#1565C0", corEscura: "#64B5F6" },
    { id: "base", titulo: "Base de cobrança", icone: "folder_shared", cor: "#6A1B9A", corEscura: TEXTO_COLORIDO_ESCURO.roxo },
    { id: "financeiro", titulo: "Boletos", icone: "request_quote", cor: "#B26A00", corEscura: "#FFB74D" },
    { id: "juridico", titulo: "Cobrança Jurídica", icone: "gavel", cor: "#37474F", corEscura: "#B0BEC5", permissao: "c085", exigeCarteiraJuridica: true },
    { id: "escritorio", titulo: "Relatórios do escritório", icone: "description", cor: "#00695C", corEscura: "#4DB6AC" },
];

export const RELATORIOS_PRONTOS = [
    {
        id: "acordos", grupo: "acordos", icone: "handshake", fonte: "acordos", colunas: COLUNAS_ACORDO,
        titulo: "Acordos",
        descricao: "Acordos formalizados por carteira, cliente, operador e situação. A tabela dinâmica se monta com os filtros escolhidos.",
        filtros: ["periodo", "carteiras", "clientes", "operadores", "situacoes"], rotuloPeriodo: "Data da formalização",
        periodoPadrao: "mes_atual", periodoQualquer: true,
        // Cada filtro com mais de uma opção (ou "Todos") vira um agrupamento da tabela dinâmica (montarDinamica)
        dinamica: {
            linhas: [
                { filtro: "carteiras", campo: "Carteira", soEscolhidas: true },
                { filtro: "clientes", campo: "Cliente Nome" },
                { filtro: "operadores", campo: "Operador Acordo" },
            ],
            colunas: [{ filtro: "situacoes", campo: "Situacao Acordo" }],
            padrao: "Operador Acordo",
            valores: [
                { campo: "ID Acordo", funcao: "count", mostrarComo: "normal", nome: "Qtd Acordos" },
                { campo: "Valor Acordo", funcao: "sum", mostrarComo: "normal", nome: "Valor dos Acordos" },
            ],
        },
        grafico: { groupColumn: "Operador Acordo", aggregateType: "sum", aggregateColumn: "Valor Acordo", chartType: "hbar" },
    },
    {
        id: "parcelas_vencer", grupo: "acordos", icone: "event_upcoming", fonte: "acordos", colunas: COLUNAS_PARCELA,
        titulo: "Parcelas a vencer",
        descricao: "Parcelas pendentes com vencimento de hoje em diante.",
        filtros: ["clientes", "carteiras", "operadores"],
        fixos: { apenasAVencer: true }, descricaoFixa: ["Somente parcelas pendentes a vencer"],
        grafico: { groupColumn: "Cliente Nome", aggregateType: "sum", aggregateColumn: "Valor Parcela", chartType: "hbar" },
    },
    {
        id: "parcelas_atraso", grupo: "acordos", icone: "running_with_errors", fonte: "acordos", colunas: COLUNAS_PARCELA,
        titulo: "Parcelas em atraso",
        descricao: "Parcelas pendentes com vencimento já passado.",
        filtros: ["clientes", "carteiras", "operadores"],
        fixos: { apenasAtrasadas: true }, descricaoFixa: ["Somente parcelas pendentes em atraso"],
        grafico: { groupColumn: "Operador Acordo", aggregateType: "sum", aggregateColumn: "Valor Parcela", chartType: "hbar" },
    },
    {
        // No formato da planilha de controle de recebimentos da ExtraJudicial (pedido da Aline, 28/10/2026)
        id: "controle_recebimentos", grupo: "acordos", icone: "payments", fonte: "recebimentos", colunas: COLUNAS_RECEBIMENTO,
        titulo: "Controle de Recebimentos",
        descricao: "Uma linha por parcela dos acordos feitos no período, inclusive os quebrados: PAGO (com a data, o valor, a forma de pagamento e se tem comprovante), A VENCER, VENCIDO e, no acordo quebrado, NÃO PAGOU (a parcela que quebrou o acordo) e QUEBRADO (as seguintes). A planilha já vem com as tabelas dinâmicas por cliente, negociador, mês do acordo, mês do pagamento e forma de pagamento.",
        filtros: ["periodo", "carteiras", "clientes", "operadores"], rotuloPeriodo: "Data do acordo",
        periodoPadrao: "ano_atual", periodoQualquer: true,
        fixos: { campoData: "formalizacao" }, descricaoFixa: ["Com os acordos quebrados (cancelados)"],
        tabelas: [
            { nome: "Status por cliente", linhas: ["Cliente Nome"], colunas: ["Status Parcela"], valores: [soma("Valor Parcela", "Total das Parcelas")] },
            { nome: "Status por negociador", linhas: ["Negociador"], colunas: ["Status Parcela"], valores: [soma("Valor Parcela", "Total das Parcelas")] },
            { nome: "Acordos por mês", linhas: ["Ano Acordo"], colunas: ["Mes Acordo"], valores: [soma("Valor Acordo", "Total dos Acordos")] },
            { nome: "Recebido por mês", linhas: ["Ano Pagamento", "Mes Pagamento"], colunas: [], valores: [soma("Valor Pago", "Total Recebido")] },
            { nome: "Forma de pagamento", linhas: ["Forma Pagamento"], colunas: [], valores: [soma("Valor Pago", "Total Recebido")] },
        ],
        grafico: { groupColumn: "Status Parcela", aggregateType: "sum", aggregateColumn: "Valor Parcela", chartType: "pie" },
    },
    {
        id: "ocorrencias_periodo", grupo: "atendimento", icone: "forum", fonte: "ocorrencias", colunas: COLUNAS_OCORRENCIA,
        titulo: "Ocorrências do período",
        descricao: "Contatos e ações registrados nas fichas, por tipo de ocorrência.",
        filtros: ["periodo", "clientes", "carteiras", "operadores", "tiposOcorrencia"], rotuloPeriodo: "Data da ocorrência", periodoPadrao: "ultimos_7",
        grafico: { groupColumn: "Tipo Ocorrencia", aggregateType: "count", aggregateColumn: "ID Ocorrencia", chartType: "hbar" },
    },
    {
        id: "ocorrencias_operador", grupo: "atendimento", icone: "support_agent", fonte: "ocorrencias", colunas: COLUNAS_OCORRENCIA,
        titulo: "Ocorrências por operador",
        descricao: "Quantas ocorrências cada operador registrou no período.",
        filtros: ["periodo", "clientes", "carteiras", "operadores", "tiposOcorrencia"], rotuloPeriodo: "Data da ocorrência", periodoPadrao: "hoje",
        grafico: { groupColumn: "Operador Ocorrencia", aggregateType: "count", aggregateColumn: "ID Ocorrencia", chartType: "hbar" },
    },
    {
        id: "contatos_nao_salvos", grupo: "atendimento", icone: "phonelink_erase", fonte: "contatos_nao_salvos", colunas: COLUNAS_CONTATO_NAO_SALVO,
        titulo: "Contatos não gravados na ficha",
        descricao: "Auditoria: telefones e e-mails informados nas ocorrências que não foram para a ficha (contato com o cliente ou desmarcado pelo operador).",
        filtros: ["periodo", "clientes", "carteiras", "operadores"], rotuloPeriodo: "Data da ocorrência", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Operador", aggregateType: "count", aggregateColumn: "ID Registro", chartType: "hbar" },
    },
    {
        id: "fichas_carteira", grupo: "base", icone: "folder_shared", fonte: "devedores", colunas: COLUNAS_FICHA,
        titulo: "Fichas por carteira",
        descricao: "Fichas da base agrupadas por carteira.",
        filtros: ["clientes", "carteiras", "operadores", "status"], exigeUmDe: RECORTE_BASE,
        grafico: { groupColumn: "Carteira", aggregateType: "count", aggregateColumn: "ID Devedor", chartType: "hbar" },
    },
    {
        id: "fichas_status", grupo: "base", icone: "donut_small", fonte: "devedores", colunas: COLUNAS_FICHA,
        titulo: "Fichas por status",
        descricao: "Distribuição das fichas pelo status configurado.",
        filtros: ["clientes", "carteiras", "operadores", "status"], exigeUmDe: RECORTE_BASE,
        grafico: { groupColumn: "Status Ficha", aggregateType: "count", aggregateColumn: "ID Devedor", chartType: "pie" },
    },
    {
        id: "fichas_operador", grupo: "base", icone: "groups", fonte: "devedores", colunas: COLUNAS_FICHA,
        titulo: "Fichas por operador",
        descricao: "Quantas fichas estão com cada operador.",
        filtros: ["clientes", "carteiras", "operadores", "status"], exigeUmDe: RECORTE_BASE,
        grafico: { groupColumn: "Operador Ficha", aggregateType: "count", aggregateColumn: "ID Devedor", chartType: "hbar" },
    },
    {
        id: "titulos_vencimento", grupo: "base", icone: "receipt_long", fonte: "contratos", colunas: COLUNAS_CONTRATO,
        titulo: "Títulos por vencimento",
        descricao: "Contratos/títulos com vencimento no período, com saldo e situação.",
        filtros: ["periodo", "clientes", "carteiras"], rotuloPeriodo: "Vencimento do título", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Situacao Contrato", aggregateType: "sum", aggregateColumn: "Saldo", chartType: "pie" },
    },
    {
        id: "boletos_periodo", grupo: "financeiro", icone: "request_quote", fonte: "boletos", colunas: COLUNAS_BOLETO,
        titulo: "Boletos do período",
        descricao: "Boletos com vencimento no período: emitidos, pagos, baixados e cancelados.",
        filtros: ["periodo", "clientes", "carteiras"], rotuloPeriodo: "Vencimento do boleto", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Situacao Boleto", aggregateType: "sum", aggregateColumn: "Valor Boleto", chartType: "pie" },
    },
    // Cobrança Jurídica: os dois relatórios do TMK. "tabelas" = as abas de tabela dinâmica que a planilha já leva
    // (as do modelo do jurídico); o nome do valor não pode ser o de uma coluna (o Excel recusa)
    {
        id: "juridico_acordos", grupo: "juridico", icone: "handshake", fonte: "acordos_juridico", colunas: COLUNAS_ACORDO_JURIDICO,
        soCarteirasJuridicas: true,
        titulo: "Acordos por data do acordo",
        descricao: "Acordos formalizados no período, sem os cancelados, com o status pelas parcelas. O acordo de honorários (HO) feito no mesmo mês do acordo principal vem nas colunas de HO da linha dele; o de outro mês, numa linha própria, no mês em que foi feito. A planilha já vem com as tabelas dinâmicas por ano e mês, status por cliente, cliente por ano e acordo e HO por cliente.",
        filtros: ["periodo", "carteiras", "clientes", "operadores"], rotuloPeriodo: "Data do acordo",
        periodoPadrao: "ano_atual", periodoQualquer: true,
        fixos: { campoData: "formalizacao" }, descricaoFixa: ["Sem os acordos cancelados"],
        tabelas: [
            { nome: "Valor por ano e mês", linhas: ["Ano Acordo"], colunas: ["Mes Acordo"], valores: [soma("Valor Acordo", "Total dos Acordos")] },
            { nome: "Acordos por ano e mês", linhas: ["Ano Acordo"], colunas: ["Mes Acordo"], valores: [contagem("ID Acordo", "Qtd de Acordos")] },
            { nome: "Status por cliente", linhas: ["Cliente Nome"], colunas: ["Status Acordo"], valores: [soma("Valor Acordo", "Total dos Acordos")] },
            { nome: "Valor por cliente e ano", linhas: ["Cliente Nome"], colunas: ["Ano Acordo"], valores: [soma("Valor Acordo", "Total dos Acordos")] },
            { nome: "Acordos por cliente e ano", linhas: ["Cliente Nome"], colunas: ["Ano Acordo"], valores: [contagem("ID Acordo", "Qtd de Acordos")] },
            {
                nome: "Acordo e HO por cliente", linhas: ["Cliente Nome"], colunas: [],
                valores: [soma("Valor Acordo", "Total dos Acordos"), soma("Valor HO", "Total de HO"), soma("Valor Acordo Mais HO", "Total Acordo + HO")],
            },
        ],
        grafico: { groupColumn: "Status Acordo", aggregateType: "sum", aggregateColumn: "Valor Acordo", chartType: "pie" },
    },
    {
        id: "juridico_parcelas", grupo: "juridico", icone: "event_note", fonte: "acordos_juridico", colunas: COLUNAS_PARCELA_JURIDICO,
        soCarteirasJuridicas: true,
        titulo: "Parcelas por vencimento",
        descricao: "Parcelas dos acordos com vencimento no período, sem os cancelados: pagas, a vencer e atrasadas, com o % e o valor do êxito. A planilha já vem com as tabelas dinâmicas por ano, consolidado por cliente, status das parcelas e recebidos por mês.",
        filtros: ["periodo", "carteiras", "clientes", "operadores"], rotuloPeriodo: "Vencimento da parcela",
        periodoPadrao: "ano_atual", periodoQualquer: true,
        periodoAteOFim: true,
        fixos: { campoData: "vencimento" }, descricaoFixa: ["Sem os acordos e as parcelas cancelados"],
        tabelas: [
            { nome: "Por ano", linhas: ["Ano Vencimento"], colunas: [], valores: [soma("Valor Parcela", "Total das Parcelas")] },
            {
                nome: "Consolidado por cliente", linhas: ["Cliente Nome"], colunas: [],
                valores: [soma("Valor Acordo", "Total dos Acordos"), soma("Valor Parcela", "Total das Parcelas"), soma("Valor Pago", "Total Pago")],
            },
            { nome: "Status das parcelas", linhas: ["Ano Vencimento"], colunas: ["Status Parcela"], valores: [soma("Valor Parcela", "Total das Parcelas")] },
            {
                nome: "Recebidos por mês", linhas: ["Ano Vencimento", "Mes Vencimento", "Status Parcela"], colunas: [],
                valores: [soma("Valor Parcela", "Total das Parcelas"), soma("Valor Pago", "Total Pago"), soma("Valor Exito", "Total do Êxito")],
            },
        ],
        grafico: { groupColumn: "Status Parcela", aggregateType: "sum", aggregateColumn: "Valor Parcela", chartType: "pie" },
    },
];

/**
 * Tabela dinâmica do relatório montada pelos filtros escolhidos: cada filtro com mais de uma opção (escolhidas ou
 * "Todos", quando a lista tem mais de uma) vira um agrupamento nas linhas, na ordem da definição; os de "soEscolhidas"
 * só quando o usuário escolhe duas ou mais. Filtro com uma opção só não agrupa (já está no título da planilha).
 * totais: quantas opções cada lista tem.
 */
export function montarDinamica(def, sel, totais) {
    const din = def.dinamica;
    if (!din) return null;
    const varias = (item) => {
        const escolhidas = (sel[item.filtro] || []).length;
        if (escolhidas) return escolhidas > 1;
        return !item.soEscolhidas && (totais[item.filtro] || 0) > 1;
    };
    const linhas = din.linhas.filter(varias).map(i => i.campo);
    const colunas = din.colunas.filter(varias).map(i => i.campo);
    return {
        linhas: linhas.length ? linhas : [din.padrao],
        colunas,
        valores: din.valores,
        filtros: [],
        agruparDatas: "mes",
        layout: "tabular",
        subtotais: "primeiro",
    };
}

const ROTULO_CAMPO_DINAMICA = { "Cliente Nome": "Cliente", "Operador Acordo": "Operador", "Situacao Acordo": "Situação", "Carteira": "Carteira" };

/** "Linhas: Cliente › Operador · Colunas: Situação" (aviso no diálogo). */
export function descreverDinamica(config) {
    if (!config) return "";
    const nome = (c) => ROTULO_CAMPO_DINAMICA[c] || c;
    const partes = [`Linhas: ${config.linhas.map(nome).join(" › ")}`];
    if (config.colunas.length) partes.push(`Colunas: ${config.colunas.map(nome).join(" › ")}`);
    partes.push(`Valores: ${config.valores.map(v => v.nome || v.campo).join(" e ")}`);
    return partes.join(" · ");
}

// Parâmetros que o SQL de um relatório customizado pode usar e o filtro da tela que os preenche
const PARAMETROS_CUSTOMIZADOS = [
    { parametros: ["startDate", "endDate"], filtro: "periodo" },
    { parametros: ["clienteIds", "clienteId", "cvIdPessoa"], filtro: "clientes" },
    { parametros: ["userIds"], filtro: "operadores" },
    { parametros: ["carteiraIds"], filtro: "carteiras" },
    { parametros: ["statusFichaIds"], filtro: "status" },
    { parametros: ["tipoOcorrenciaIds"], filtro: "tiposOcorrencia" },
    { parametros: ["situations"], filtro: "situacoes" },
];

export const PARAMETROS_SQL_AJUDA = ":startDate e :endDate (período), :clienteIds e :carteiraIds (em branco = todos), :userIds (operadores), "
    + ":statusFichaIds, :tipoOcorrenciaIds e :situations. Automáticos, sem filtro na tela e preenchidos pelo sistema com o que "
    + "quem gera pode ver: :escopoClientes (clientes liberados) e :escopoCarteiras (carteiras das equipes); ex.: AND d.cvIdPessoa IN "
    + "(:escopoClientes) AND dc.cvIdCarteira IN (:escopoCarteiras)";

/** Relatório customizado (cadastrado pelo admin) no formato do catálogo: os filtros saem dos parâmetros do SQL. */
export function definicaoCustomizada(item) {
    // Parâmetros ":nome" do SQL (fora de textos entre aspas)
    const sql = (item.ccQuerySql || "").replace(/'([^']|'')*'/g, "''");
    const usados = new Set(Array.from(sql.matchAll(/(^|[^:\w]):([A-Za-z_]\w*)/g), m => m[2]));
    const usa = (p) => usados.has(p);
    const filtros = PARAMETROS_CUSTOMIZADOS.filter(p => p.parametros.some(usa)).map(p => p.filtro);
    return {
        id: `custom_${item.cvId}`,
        grupo: "escritorio",
        icone: "description",
        fonte: `custom_${item.cvId}`,
        colunas: [],
        titulo: item.ccNome,
        descricao: item.ccDescricao || "Relatório cadastrado pelo escritório.",
        filtros,
        // Parâmetro do SQL sem valor não roda: todo filtro que o SQL usa é obrigatório, menos cliente e carteira
        // (em branco = todos; o backend troca :clienteIds/:carteiraIds pela lista de todos os que o usuário vê)
        obrigatorios: filtros.filter(f => f !== "clientes" && f !== "carteiras"),
        periodoPadrao: filtros.includes("periodo") ? "mes_atual" : undefined,
        rotuloPeriodo: "Período",
        customizado: true,
        temTemplate: Boolean(item.ccTemplateArquivo),
    };
}

// ---------- Período ----------

export const PERIODOS = [
    { id: "hoje", label: "Hoje" },
    { id: "ontem", label: "Ontem" },
    { id: "ultimos_7", label: "Últimos 7 dias" },
    { id: "mes_atual", label: "Este mês" },
    { id: "mes_passado", label: "Mês passado" },
    { id: "ano_atual", label: "Este ano" },
    { id: "personalizado", label: "Outro período" },
];
export const PERIODO_QUALQUER = { id: "todos", label: "Qualquer data" };

const pad = (n) => String(n).padStart(2, "0");
export const isoData = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const dataBr = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

/** { inicio, fim } em yyyy-MM-dd para o período escolhido; "todos" = sem datas. */
// ateOFim: "Este mês" e "Este ano" vão até o último dia (relatório por vencimento, que tem datas futuras); senão, até hoje
export function intervaloDoPeriodo(periodo, inicioPersonalizado, fimPersonalizado, hoje = new Date(), ateOFim = false) {
    const d = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
    switch (periodo) {
        case "hoje": return { inicio: isoData(d), fim: isoData(d) };
        case "ontem": {
            const o = new Date(d); o.setDate(o.getDate() - 1);
            return { inicio: isoData(o), fim: isoData(o) };
        }
        case "ultimos_7": {
            const i = new Date(d); i.setDate(i.getDate() - 6);
            return { inicio: isoData(i), fim: isoData(d) };
        }
        case "mes_atual": return { inicio: isoData(new Date(d.getFullYear(), d.getMonth(), 1)), fim: isoData(ateOFim ? new Date(d.getFullYear(), d.getMonth() + 1, 0) : d) };
        case "mes_passado": return {
            inicio: isoData(new Date(d.getFullYear(), d.getMonth() - 1, 1)),
            fim: isoData(new Date(d.getFullYear(), d.getMonth(), 0)),
        };
        case "ano_atual": return { inicio: isoData(new Date(d.getFullYear(), 0, 1)), fim: isoData(ateOFim ? new Date(d.getFullYear(), 11, 31) : d) };
        case "personalizado": return { inicio: inicioPersonalizado || "", fim: fimPersonalizado || "" };
        default: return { inicio: "", fim: "" };
    }
}

// ---------- Opções dos filtros (mesmos campos que o assistente usa) ----------

export const rotuloOperador = (o) => o.nome || o.ccNome || o.name || o.ccLogin || (o.id ? `Operador ${o.id}` : "");
export const rotuloCliente = (c) => c.nomeComum || c.nomeCompleto || c.ccNomeComum || c.ccNomeCompleto || c.nome || c.name || (c.id ? `Cliente ${c.id}` : "");
export const rotuloCarteira = (c) => c.nome || c.ccNome || c.name || (c.id ? `Carteira ${c.id}` : "");
export const rotuloStatus = (s) => s.ccNome || s.nome || s.name || (s.id ? `Status ${s.id}` : "");
export const rotuloTipoOcorrencia = (t) => t.nome || t.ccNome || t.name || (t.id ? `Ocorrência ${t.id}` : "");
export const rotuloSituacao = (s) => s.name || s.label || s.nome || `Situação ${s.id}`;

export const FILTROS = {
    clientes: { label: "Cliente", plural: "Clientes", placeholder: "Todos os clientes", rotulo: rotuloCliente, valor: (c) => c.id || c.cvId, lista: "clientes" },
    operadores: { label: "Operador", plural: "Operadores", placeholder: "Todos os operadores", rotulo: rotuloOperador, valor: (o) => o.id || o.cvCodUsuario || o.cvId, lista: "operadores" },
    carteiras: { label: "Carteira", plural: "Carteiras", placeholder: "Todas as carteiras", rotulo: rotuloCarteira, valor: (c) => c.id || c.cvId, lista: "carteiras" },
    status: { label: "Status da ficha", plural: "Status da ficha", placeholder: "Todos os status", rotulo: rotuloStatus, valor: (s) => s.id || s.cvId, lista: "status" },
    situacoes: { label: "Situação do acordo", plural: "Situação do acordo", placeholder: "Todas as situações", rotulo: rotuloSituacao, valor: (s) => s.id, lista: "situacoes" },
    tiposOcorrencia: { label: "Tipo de ocorrência", plural: "Tipos de ocorrência", placeholder: "Todos os tipos", rotulo: rotuloTipoOcorrencia, valor: (t) => t.id || t.cvId, lista: "tiposOcorrencia" },
};

export const opcoesDe = (chave, lista) => (lista || []).map(item => ({ ...item, value: FILTROS[chave].valor(item), label: FILTROS[chave].rotulo(item) }));

// As listas de carteiras e clientes já vêm só com o que o usuário pode ver (carteiras das equipes, clientes liberados).
// Com uma só, o filtro já nasce com ela e não muda.
const FILTROS_TRAVAVEIS = ["carteiras", "clientes"];
export const AVISO_TRAVADO = { carteiras: "Única carteira liberada para você.", clientes: "Único cliente liberado para você." };

/** { carteiras: [opção], clientes: [opção] } para os filtros com uma só opção visível. */
/** Listas do diálogo do relatório: nos da Cobrança Jurídica, só as carteiras jurídicas (os dados também são só delas). */
export function listasDoRelatorio(def, listas) {
    if (!def || !def.soCarteirasJuridicas) return listas;
    return { ...listas, carteiras: (listas.carteiras || []).filter(ehCarteiraJuridica) };
}

export function filtrosTravados(listas) {
    const travados = {};
    FILTROS_TRAVAVEIS.forEach(chave => {
        const lista = (listas && listas[FILTROS[chave].lista]) || [];
        if (lista.length === 1) travados[chave] = opcoesDe(chave, lista);
    });
    return travados;
}

/** Mesmos itens escolhidos (pelo id), para não regravar o filtro travado a cada renderização. */
export const mesmaSelecao = (chave, atual, fixo) => (atual || []).map(o => String(FILTROS[chave].valor(o))).join("|")
    === (fixo || []).map(o => String(FILTROS[chave].valor(o))).join("|");

// ---------- Filtros para o backend e descrição para a planilha ----------

/** Corpo "filtros" de /reports/run e /reports/export-xlsx a partir do que foi escolhido no diálogo. */
export function montarFiltros(def, sel) {
    const { inicio, fim } = intervaloDoPeriodo(sel.periodo, sel.inicio, sel.fim, undefined, def.periodoAteOFim);
    const fixos = def.fixos || {};
    return {
        startDate: def.filtros.includes("periodo") ? inicio : "",
        endDate: def.filtros.includes("periodo") ? fim : "",
        userIds: (sel.operadores || []).map(o => o.cvCodUsuario || o.id || o.cvId),
        statusFichaIds: (sel.status || []).map(s => s.cvId || s.id),
        carteiraIds: (sel.carteiras || []).map(c => c.cvId || c.id),
        situations: fixos.situations || (sel.situacoes || []).map(s => s.id),
        tipoOcorrenciaIds: (sel.tiposOcorrencia || []).map(t => t.cvId || t.id),
        clienteIds: (sel.clientes || []).map(c => c.id || c.cvId),
        excetoDevolvidos: false,
        semAtraso: false,
        apenasAVencer: Boolean(fixos.apenasAVencer),
        apenasAtrasadas: Boolean(fixos.apenasAtrasadas),
        ...(fixos.campoData ? { campoData: fixos.campoData } : {}),
        selectedColumns: def.colunas || [],
        columnAliases: {},
    };
}

function listaCurta(itens, rotulo) {
    const nomes = itens.map(rotulo).filter(Boolean);
    return nomes.length > 5 ? `${nomes.slice(0, 5).join(", ")} e mais ${nomes.length - 5}` : nomes.join(", ");
}

/** Filtros aplicados em texto, para o topo da planilha e para a tela de resultado. */
export function descreverFiltros(def, sel) {
    const partes = [];
    if (def.filtros.includes("periodo")) {
        const { inicio, fim } = intervaloDoPeriodo(sel.periodo, sel.inicio, sel.fim, undefined, def.periodoAteOFim);
        if (inicio || fim) partes.push(`${def.rotuloPeriodo || "Período"}: ${dataBr(inicio) || "início"} a ${dataBr(fim) || "hoje"}`);
    }
    Object.keys(FILTROS).forEach(chave => {
        const itens = sel[chave] || [];
        if (def.filtros.includes(chave) && itens.length > 0) {
            partes.push(`${itens.length > 1 ? FILTROS[chave].plural : FILTROS[chave].label}: ${listaCurta(itens, FILTROS[chave].rotulo)}`);
        }
    });
    return [...partes, ...(def.descricaoFixa || [])];
}

/** Mensagem do que falta escolher, ou null quando dá para gerar. */
export function validarSelecao(def, sel) {
    const obrigatorios = def.obrigatorios || [];
    if (def.filtros.includes("periodo")) {
        const { inicio, fim } = intervaloDoPeriodo(sel.periodo, sel.inicio, sel.fim, undefined, def.periodoAteOFim);
        if (sel.periodo === "personalizado" && inicio && fim && inicio > fim) return "A data inicial é depois da data final.";
        if ((obrigatorios.includes("periodo") || sel.periodo === "personalizado") && (!inicio || !fim)) {
            return "Informe a data inicial e a data final.";
        }
    }
    const faltando = obrigatorios.filter(f => f !== "periodo" && !(sel[f] || []).length).map(f => FILTROS[f].label.toLowerCase());
    if (faltando.length) return `Este relatório precisa do filtro: ${faltando.join(", ")}.`;
    if (def.exigeUmDe && !def.exigeUmDe.some(f => (sel[f] || []).length)) {
        return `Escolha ao menos ${def.exigeUmDe.map(f => FILTROS[f].label.toLowerCase()).join(", ").replace(/, ([^,]*)$/, " ou $1")}: a base inteira é grande demais para gerar de uma vez.`;
    }
    return null;
}

export const selecaoInicial = (def) => ({
    periodo: def.periodoPadrao || (def.filtros.includes("periodo") ? "mes_atual" : "todos"),
    inicio: "",
    fim: "",
    clientes: [],
    operadores: [],
    carteiras: [],
    status: [],
    situacoes: [],
    tiposOcorrencia: [],
});

/** "acordos_por_operador_20261003_1432.xlsx" */
export function nomeArquivo(titulo, agora = new Date()) {
    const base = (titulo || "relatorio").normalize("NFD").replace(/\p{M}/gu, "").replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_|_$/g, "").toLowerCase();
    return `${base || "relatorio"}_${agora.getFullYear()}${pad(agora.getMonth() + 1)}${pad(agora.getDate())}_${pad(agora.getHours())}${pad(agora.getMinutes())}.xlsx`;
}

/** Busca no catálogo: título, descrição e grupo, sem diferenciar acentos. */
export function correspondeBuscaRelatorio(def, termo) {
    const norm = (s) => (s || "").normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
    const t = norm(termo).trim();
    if (!t) return true;
    const grupo = GRUPOS_RELATORIOS.find(g => g.id === def.grupo);
    return [def.titulo, def.descricao, grupo?.titulo].some(c => norm(c).includes(t));
}
